import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input()
  count: number;

  @Input()
  itemsPerPage: number;

  @Input()
  page: number;

  @Input()
  numberOfPages: number;

  @Output()
  onPageChange = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  nextPage() {
    if (this.page < this.numberOfPages) {
      this.page = this.page + 1;
      this.onPageChange.emit(this.page);
    }
  }

  previousPage() {
    if (this.page > 0) {
      this.page = this.page - 1;
      this.onPageChange.emit(this.page);
    }
  }
}
